import { FC } from 'react';

interface Props {
    message: string;
}

const ErrorText: FC<Props> = ({ message }) => {
    if (!message) return null;
    return <p className="errorText">{message}</p>;
};

export default ErrorText;
